import React from 'react';

import ExternalContent from '../components/ExternalContent';
import Logo from '../components/Logo';

const makeExternalTab = (options) => {
  const { src, label, url } = options;
  return {
    label,
    url,
    icon: <Logo />,
    content: (props) => <ExternalContent src={src} title={label} {...props} />,
  };
};

export default makeExternalTab;
